import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

function ContactForm() {
    const initialValues = {
        name: "",
        email: "",
        phone: "",
        message: ""
    };

    const validationSchema = Yup.object({
        name: Yup.string().required("İsim zorunludur"),
        email: Yup.string().email("Geçerli bir email adresi girin").required("Email zorunludur"),
        phone: Yup.string().min(10, "Telefon numarası en az 10 haneli olmalı").required("Telefon zorunludur"),
        message: Yup.string().required("Mesaj zorunludur"),
    });

    console.log({
        href: window.location.href,
        hostname: window.location.hostname,
        search: window.location.search,
    });

    const onSubmit = (values, { resetForm }) => {
        console.log(values);
        alert("Form başarıyla gönderildi!");
        resetForm();
    };

    return (
        <section id="contact" className="py-5 bg-light">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="fw-bold">Bize Ulaşın</h2>
                    <p className="lead">Her türlü soru ve destek talepleriniz için bizimle iletişime geçin.</p>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="p-4 shadow rounded bg-white">
                            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                                <Form>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">İsim</label>
                                        <Field name="name" type="text" className="form-control" placeholder="İsminizi girin" />
                                        <ErrorMessage name="name" component="div" className="text-danger small mt-1" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <Field name="email" type="email" className="form-control" placeholder="Email adresinizi girin" />
                                        <ErrorMessage name="email" component="div" className="text-danger small mt-1" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Telefon</label>
                                        <Field name="phone" type="phone" className="form-control" placeholder="Telefon numaranızı girin" />
                                        <ErrorMessage name="phone" component="div" className="text-danger small mt-1" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="message" className="form-label">Mesajınız</label>
                                        <Field name="message" as="textarea" className="form-control" placeholder="Mesajınızı yazın" rows="5" />
                                        <ErrorMessage name="message" component="div" className="text-danger small mt-1" />
                                    </div>

                                    <div className="d-grid">
                                        <button type="submit" className="btn btn-primary btn-lg">Gönder</button>
                                    </div>
                                </Form>
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactForm;